'use client'

import { Box, Typography } from '@mui/material'

import SmilesLogo from '@/src/assets/svgs/SmilesLogo'

export interface SmilesBannerProps {
    message: string
}

const SmilesBanner = ({ message }: SmilesBannerProps) => (
    <Box
        sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.25,
            px: 2,
            py: 1.5,
            bgcolor: 'common.black'
        }}
    >
        <SmilesLogo sx={{ width: 30, height: 30 }} />
        <Typography sx={{ color: 'common.white', fontSize: '14px', fontWeight: 500, lineHeight: 1.35 }}>
            {message}
        </Typography>
    </Box>
)

export { SmilesBanner }
export default SmilesBanner
